(() => {
    function getRadioWeight(group) {
  if (!group) return null;
  const checked = group.querySelector('input[type="radio"]:checked') || group.querySelector('input[type="radio"]');
  return checked ? checked.getAttribute("data-weight") : null;
}
    function processTwo(el_rod_length_input, el_number_of_panels_select, el_pleat_style_select, el_result_order, el_result_rings, el_result_width) {
  const pleatStyleBaseValueMap = {
    double: {
      range: [1.5, 4],
      interval: {
        lt: 2.4,
        ltgt: 2.2,
        gt: 2,
      },
      widthRange: [0.8, 1.2],
    },
    triple: {
      range: [1, 4],
      interval: {
        lt: 2.4,
        ltgt: 2.2,
        gt: 2,
      },
      widthRange: [1.5, 2],
    },
  };
  const el_rod_length = parseFloat(el_rod_length_input.value) || 0;
  const el_number_of_panels = el_number_of_panels_select.options[el_number_of_panels_select.selectedIndex].getAttribute("data-weight");
  const pleat_style_value = getRadioWeight(el_pleat_style_select);
  const base_value = pleatStyleBaseValueMap[pleat_style_value];
  if (el_rod_length === 0 || !base_value) {
    el_rod_length_input.classList.add("el-highlight-error");
    el_result_order.innerHTML = "-";
    el_result_rings.innerHTML = "-";
    el_result_width.innerHTML = "-";
    throw new Error("cozy-calculator validation failed: rod_length is required");
  }
  const rodLengthMeters = el_rod_length * 0.0254;
  const orderValue = rodLengthMeters * el_number_of_panels;
  const orderValueToInchs = orderValue / 0.0254;
  const roundedOrderValueToInchs = parseInt(orderValueToInchs * 10, 10) / 10;
  let ringsValue;
  if (orderValue <= base_value.range[0]) {
    ringsValue = Math.ceil((orderValue * base_value.interval.lt) / 0.24);
  } else if (orderValue >= base_value.range[1]) {
    ringsValue = Math.ceil((orderValue * base_value.interval.gt) / 0.24);
  } else {
    ringsValue = Math.ceil((orderValue * base_value.interval.ltgt) / 0.24);
  }
  const widthRangeRet = `${Math.round(ringsValue * base_value.widthRange[0])} ~ ${Math.round(ringsValue * base_value.widthRange[1])}`;
  el_result_order.innerHTML = `≈ ${roundedOrderValueToInchs}`;
  el_result_rings.innerHTML = `≈ ${ringsValue}`;
  el_result_width.innerHTML = `≈ ${widthRangeRet}`;
}
    function fromRodWidth(widthIn, panels, style) {
      if (!Number.isFinite(widthIn) || widthIn <= 0 || ![1,2].includes(panels) || !['double','triple'].includes(style)) {
        throw new Error('Valid width, panel quantity and header group are required.');
      }
      // DOM-shaped inputs let the unchanged calculator function run without
      // mounting its UI. Single/Split weights match the existing calculator.
      const width = {value:String(widthIn), classList:{add(){}}};
      const quantity = {selectedIndex:0, options:[{getAttribute(){return String(1 / panels);}}]};
      const group = {querySelector(){return {getAttribute(){return style;}};}};
      const order = {}, count = {}, stack = {};
      processTwo(width, quantity, group, order, count, stack);
      const number = text => Number(String(text).replace(/[^0-9.-]/g, ''));
      const value = number(count.innerHTML);
      const stackRange = String(stack.innerHTML).split('~').map(number);
      if (!Number.isInteger(value) || value < 1 || stackRange.length !== 2 || !stackRange.every(Number.isFinite)) {
        throw new Error('Calculator output contract changed; verify the report adapter.');
      }
      return {count:value, orderWidth:number(order.innerHTML), stackRange};
    }
    window.CozyologyCountMath = Object.freeze({
      sourceHash:"825594eabdc77b2d69c55b2c29339deb88ea6d6c85a3a13364357686254f1842",
      fromRodWidth,
      rippleCount(widthPerPanel) { return fromRodWidth(widthPerPanel, 1, 'double').count; }
    });
  })();